import {isValidation, IValidation, IValidationGroup, IValidationGroupType, ValidationGroupType, ValidationType} from '@core/api/data-access';

import {ValidationModel} from './validation.abstract.model';
import {ValidationModelFactory} from './validation.factory';
import {isOldConditionsArray, migrateConditionsArray} from './validation.migration';

export class ValidationGroupModel implements IValidationGroup {
	public groupType: ValidationGroupType = null;
	public validations: ValidationModel[] = [];

	validationsByType(): Record<ValidationType, ValidationModel> {
		return this.validations.reduce(
			(acc: Record<ValidationType, ValidationModel>, validation: ValidationModel) => {
				acc[validation.type] = validation;
				return acc;
			},
			{} as Record<ValidationType, ValidationModel>,
		);
	}

	constructor(init?: Partial<ValidationGroupModel>) {
		Object.assign(this, init);
	}

	/**
	 * @description
	 * 		for each json:
	 * 		if the json in structure of IValidationGroupType, then update the groupType
	 * 		else, if the json in structure of IValidation, then create a ValidationModel and add it to the ValidationGroupModel
	 * @param jsons
	 */
	public static fromJsonStringsArray(jsons: string[]): ValidationGroupModel {
		if (!jsons?.length) {
			return new ValidationGroupModel();
		}
		if (isOldConditionsArray(jsons)) return migrateConditionsArray(jsons);
		const validationGroup: ValidationGroupModel = migrateConditionsArray(jsons);
		for (const json of jsons) {
			const parsed = JSON.tryParse<any>(json);
			if (parsed) {
				if (parsed.groupType) {
					validationGroup.groupType = parsed.groupType;
					// for fields validation, the whole validatoin data in one json:
					if (parsed?.validations?.length) parsed.validations.forEach((validation: IValidation) => validationGroup.addValidation(validation));
				} else {
					validationGroup.addValidation(parsed as IValidation);
				}
			}
		}

		if (!validationGroup?.groupType) {
			return new ValidationGroupModel();
		}

		return validationGroup;
	}

	public addValidation(validation: IValidation): void {
		// input validation structure:
		if (isValidation(validation)) {
			this.validations.push(ValidationModelFactory(validation));
		}
	}

	/* -------------------------------------------------------------------------------------------------------------- */
	public isValid(): boolean {
		return this.validations.every(validation => validation.isValid());
	}

	public toJSON(): IValidationGroup {
		return {
			groupType: this.groupType,
			validations: this.validations.map(validation => validation.toJSON()),
		};
	}

	public toGroupsStringsArray(): string[] {
		const jsons = [];
		if (!this?.groupType) return jsons;
		// First json	is the groupType:
		const groupTypeJSON: IValidationGroupType = {groupType: this?.groupType};
		jsons.push(JSON.stringify(groupTypeJSON));

		// Rest of jsons are the validations:
		for (const validation of this.validations) {
			jsons.push(JSON.stringify(validation.toJSON()));
		}
		return jsons;
	}
}
